// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"836":"6dc493c5","971":"50cf35a0","5974":"6dc493c5","7687":"6dc493c5"}[chunkId] + ".chunk.css";
};